/**
 * GetUserPremiumPackagesUseCase
 *
 * Loads user's premium package subscriptions from local SecureStorage.
 * Data is populated by syncSecureStorageUseCase during sync.
 */
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { UserPremiumPackageStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import type { UserPremiumPackageEntity } from '@/domain/entities/userPremiumPackage/userPremiumPackageEntity';
import { UserPremiumPackageRemapper } from '@/domain/remappers/userPremiumPackage/userPremiumPackageRemapper';

export class GetUserPremiumPackagesUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage ?? SecureStorageWebCrypto.getInstance();
  }

  async execute(): Promise<UserPremiumPackageEntity[]> {
    const storageItems = await this.storage.getAllWithPrefix<UserPremiumPackageStorage>(
      SECURE_STORAGE_KEYS.USER_PREMIUM_PACKAGES
    );

    return UserPremiumPackageRemapper.fromStorageList(storageItems);
  }
}

export const createGetUserPremiumPackagesUseCase = (): GetUserPremiumPackagesUseCase => {
  return new GetUserPremiumPackagesUseCase();
};
